import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseSaveSectionComponent } from '../base-save-section.component';
import { ReferenceDataLabels } from './../../../../lib/constants/reference-data-labels';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';
import { MortgageApplicationService } from './../../services/mortgage-application.service';

@Component({
  selector: 'boi-save-fact-find2',
  templateUrl: './save-factfind2.component.html',
  styleUrls: ['./save-factfind2.component.scss']
})
export class SaveFactFind2Component extends BaseSaveSectionComponent implements OnDestroy {
  @Output() public readonly save = new EventEmitter<any>();
  @Output() public readonly cancel = new EventEmitter<any>();

  constructor(
    protected readonly mortgageApplicationStore: MortgageApplicationStore,
    protected readonly mortgageApplicationService: MortgageApplicationService,
    protected readonly router: Router,
    public readonly route: ActivatedRoute
  ) {
    super(mortgageApplicationStore, mortgageApplicationService, router, route);
    this.saveButtonLabel = ReferenceDataLabels.SaveContinueId;
  }

  public saveApplication(): void {
    const mortgageApplication = this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity;

    this.mortgageApplicationService.prepareDataForSave(mortgageApplication);

    const isApplicationReadonly = mortgageApplication.IsApplicationReadOnly;
    const isFactFindReadonly = mortgageApplication.IsFactFindReadOnly;

    this.mortgageApplicationService
      .saveFactFind2(mortgageApplication)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data) => {
        data.mortgageApplicationEntity.IsApplicationReadOnly = isApplicationReadonly;
        data.mortgageApplicationEntity.IsFactFindReadOnly = isFactFindReadonly;
        this.mortgageApplicationStore.mortgageApplicationResponse = data;
        this.save.emit();
      });
  }
}
